module.exports = __webpack_public_path__ + "img/your_answer.c50ad0bb.svg";